import React from 'react';

import cwmLogoPrimary from '../../assets/brand/cwm-logo-primary.png';
import cwmLogoWordmark from '../../assets/brand/cwm-logo-wordmark.png';
import cwmLogoWordmarkWhite from '../../assets/brand/cwm-logo-wordmark-white.png';
import cwmLogoStackedWhite from '../../assets/brand/cwm-logo-stacked-white.png';
import cwmLogoMarkWhite from '../../assets/brand/cwm-logo-mark-white.png';
import cwmLogoMarkBlue from '../../assets/brand/cwm-logo-mark-blue.png';
import cwmLogoMascot from '../../assets/brand/cwm-logo-mascot.png';
import cwmLogoMascotWhite from '../../assets/brand/cwm-logo-mascot-white.png';
import cwmLogoIcon from '../../assets/brand/cwm-logo-icon.png';

const LOGO_SRC = {
  primary: cwmLogoPrimary,
  wordmark: cwmLogoWordmark,
  'wordmark-white': cwmLogoWordmarkWhite,
  'stacked-white': cwmLogoStackedWhite,
  'mark-white': cwmLogoMarkWhite,
  'mark-blue': cwmLogoMarkBlue,
  mascot: cwmLogoMascot,
  'mascot-white': cwmLogoMascotWhite,
  icon: cwmLogoIcon,
};

export function Logo({ height = 38, variant = 'primary', alt = 'Chat With Menu', style, ...rest }) {
  const src = LOGO_SRC[variant] || LOGO_SRC.primary;
  return <img src={src} alt={alt} style={{ height, display: 'block', ...style }} {...rest} />;
}

const CWM_ICONS = {
  explore: 'M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6.5L14 14l-5.5 1.5L10 10l5.5-1.5z',
  play_circle: 'M12 2a10 10 0 100 20 10 10 0 000-20zm-2 6l6 4-6 4V8z',
  rocket_launch: 'M14 6l4 4-6 8-4-4 6-8zm-2 10a2 2 0 110 4 2 2 0 010-4zm6-12l2 2M4 14l2 2',
  calendar_month: 'M7 3v3M17 3v3M3 8h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z',
  dashboard: 'M3 3h7v9H3zM14 3h7v5h-7zM14 11h7v10h-7zM3 15h7v6H3z',
  trending_up: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  local_fire_department: 'M12 3s4 4 4 8a4 4 0 01-8 0c0-2 1-3 2-4 0 1 0 2 1 2 0-2 1-4 1-6z',
  verified_user: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  verified: 'M12 3l2 2 3-1 1 3 3 1-1 3 1 3-3 1-1 3-3-1-2 2-2-2-3 1-1-3-3-1 1-3-1-3 3-1 1-3 3 1zM9 12l2 2 4-4',
  loyalty: 'M20 12L12 4H4v8l8 8 8-8zM7 8a1 1 0 102 0 1 1 0 00-2 0z',
  psychology: 'M12 2a7 7 0 017 7v3l2 3h-3v3a2 2 0 01-2 2h-2v3h-4v-5a5 5 0 01-5-5V9a7 7 0 017-7z',
  restaurant_menu: 'M4 4h10v6H4zM4 13h10v6H4zM17 4h3v16h-3z',
  restaurant: 'M7 2v9M11 2v9M7 6h4M11 2h2v9h-2zM9 11v11M18 2c-2 0-3 3-3 6s1 5 3 5v9',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  warning_amber: 'M12 2l10 18H2zM12 9v5M12 17h.01',
  check: 'M5 12l5 5L20 7',
  check_circle: 'M22 11.1V12a10 10 0 11-5.9-9.1M22 4L12 14.1l-3-3',
  info: 'M12 2a10 10 0 100 20 10 10 0 000-20zM12 8h.01M11 12h1v5h1',
  close: 'M6 6l12 12M6 18L18 6',
  arrow_back: 'M19 12H5M12 19l-7-7 7-7',
  arrow_forward: 'M5 12h14M12 5l7 7-7 7',
  arrow_right: 'M5 12h14M12 5l7 7-7 7',
  add: 'M12 5v14M5 12h14',
  delete_outline: 'M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M6 6v14a2 2 0 002 2h8a2 2 0 002-2V6M10 11v6M14 11v6',
  upload: 'M12 3v14M5 10l7-7 7 7M5 21h14',
  swap_horiz: 'M16 3l4 4-4 4M4 7h16M8 21l-4-4 4-4M20 17H4',
  cloud_done: 'M7 18a5 5 0 110-10 6 6 0 0111 3 4 4 0 01-1 8H7zM9 13l2 2 4-4',
  image: 'M3 4h18v16H3zM3 16l5-5 4 4 3-3 6 6',
  logout: 'M10 17l-5-5 5-5M5 12h14M15 4h4a2 2 0 012 2v12a2 2 0 01-2 2h-4',
  star: 'M12 2l3 7 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z',
  favorite: 'M12 21c-5-4.5-9-7.5-9-12a5 5 0 019-3 5 5 0 019 3c0 4.5-4 7.5-9 12z',
  auto_graph: 'M3 17l5-5 4 4 7-7M17 9h3v3',
  groups: 'M9 11a3 3 0 100-6 3 3 0 000 6zM17 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM3 19c0-3 3-5 6-5s6 2 6 5M16 19c0-2 1.5-4 4-4',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35',
  storefront: 'M3 9l2-5h14l2 5M3 9v11h18V9M3 9a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0',
  bell: 'M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0',
  chat: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  location_on: 'M12 2a7 7 0 017 7c0 5-7 13-7 13s-7-8-7-13a7 7 0 017-7zM12 6a3 3 0 100 6 3 3 0 000-6z',
  chevron_right: 'M9 6l6 6-6 6',
  chevron_left: 'M15 6l-6 6 6 6',
  menu_book: 'M4 4h7v16H4zM13 4h7v16h-7zM4 8h7M4 12h7M13 8h7M13 12h7',
  edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z',
  savings: 'M12 3a7 7 0 00-7 7v5a3 3 0 003 3h8a3 3 0 003-3v-5a7 7 0 00-7-7zM9 11h.01M15 11h.01M12 14v2',
  pause: 'M6 4h4v16H6zM14 4h4v16h-4z',
  play_arrow: 'M8 5v14l11-7z',
  send: 'M22 2L11 13M22 2l-7 20-4-9-9-4z',
  share: 'M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13',
  place: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0zM12 7a3 3 0 100 6 3 3 0 000-6z',
  language: 'M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2a15 15 0 010 20M12 2a15 15 0 000 20',
  chat_bubble: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  lock: 'M5 11h14v10H5zM8 11V7a4 4 0 018 0v4',
  visibility: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12zM12 9a3 3 0 100 6 3 3 0 000-6z',
  mail: 'M3 7l9 6 9-6M3 7h18v10H3z',
  sparkles: 'M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2z',
  play_circle_filled: 'M12 2a10 10 0 100 20 10 10 0 000-20zm-2 6l6 4-6 4V8z',
  bolt: 'M13 2L3 14h7l-1 8 10-12h-7z',
  trophy: 'M7 4h10v4a5 5 0 01-10 0zM10 14h4v4h-4zM8 21h8',
  redeem: 'M4 7h16v4H4zM5 11v10h14V11M12 7v14M9 3l3 4 3-4',
  card_giftcard: 'M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7c-4 0-4-5 0-5s0 5 0 5zM12 7c4 0 4-5 0-5s0 5 0 5z',
};

export function Icon({ name, size = 20, color, style }) {
  const path = CWM_ICONS[name];
  if (!path) {
    return <span style={{ display: 'inline-block', width: size, height: size, ...style }} />;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
    >
      <path d={path} />
    </svg>
  );
}

export function Tag({ label, tone = 1, solid = false, icon }) {
  const style = solid
    ? { background: `var(--cwm-grp-${tone}-solid)`, color: '#fff', borderColor: 'transparent' }
    : { background: `var(--cwm-grp-${tone}-bg)`, color: `var(--cwm-grp-${tone}-fg)`, borderColor: `var(--cwm-grp-${tone}-br)` };
  return (
    <span className="cwm-tag" style={{ border: '1px solid', ...style }}>
      {icon && <Icon name={icon} size={12} />} {label}
    </span>
  );
}

export function StatusPill({ open = true, children }) {
  const ok = open;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        padding: '4px 11px',
        borderRadius: 999,
        color: ok ? 'var(--cwm-green-text)' : 'var(--cwm-red-text)',
        fontWeight: 800,
        fontSize: 11,
        boxShadow: 'var(--cwm-shadow-soft)',
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: 999, background: 'currentColor' }} />
      {children ?? (ok ? 'Open' : 'Closed')}
    </span>
  );
}

export function Rating({ value }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        padding: '4px 11px',
        borderRadius: 999,
        color: 'var(--cwm-star)',
        fontWeight: 800,
        fontSize: 11.5,
        boxShadow: 'var(--cwm-shadow-soft)',
      }}
    >
      <Icon name="star" size={13} /> {value}
    </span>
  );
}

export function Eyebrow({ children, style }) {
  return <div className="cwm-eyebrow-badge" style={style}>{children}</div>;
}
